import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: '#0a0a0a', color: '#f2f2f2',
        padding: '2rem', fontFamily: 'monospace', overflowY: 'auto'
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <p style={{ color: '#ef4444', fontWeight: 700, fontSize: 18, marginBottom: 8 }}>
            Erreur React — copiez ce message pour le diagnostic
          </p>
          <pre style={{
            background: '#1a1a1a', padding: 16, borderRadius: 8,
            color: '#ef4444', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            marginBottom: 16, fontSize: 13
          }}>
            {error.toString()}
          </pre>
          {info?.componentStack && (
            <pre style={{
              background: '#1a1a1a', padding: 16, borderRadius: 8,
              color: '#8a8a8a', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
              fontSize: 12
            }}>
              {info.componentStack}
            </pre>
          )}
          <button
            onClick={() => { localStorage.clear(); window.location.reload(); }}
            style={{
              marginTop: 16, padding: '10px 20px', background: '#4FB367',
              color: '#000', border: 'none', borderRadius: 8,
              cursor: 'pointer', fontWeight: 700, fontSize: 14
            }}
          >
            Vider le cache et recharger
          </button>
        </div>
      </div>
    );
  }
}
